import { render, staticRenderFns } from "./news-card2.vue?vue&type=template&id=2149ef9c&scoped=true&"
import script from "./news-card2.vue?vue&type=script&lang=js&"
export * from "./news-card2.vue?vue&type=script&lang=js&"
import style0 from "./news-card2.vue?vue&type=style&index=0&id=2149ef9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2149ef9c",
  null
  
)

export default component.exports